import { Injectable, inject } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";

export interface IiFirmDeliveryMethod {
    Id: number;
    Sequence: number;
    IsDefault: boolean;
    InUse: boolean;
    CanDelete: boolean;
    DisplayName: string;
    "en-CA": string;
    "fr-CA": string;
}

@Injectable()
export class IFirmDeliveryMethodsService {
    private iframeMessagesService = inject(IframeMessagesService);
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);
    private iFirmDeliveryMethodsLoadPromise: Promise<IiFirmDeliveryMethod[]>;

    iFirmDeliveryMethods: IiFirmDeliveryMethod[] = [];

    constructor() {}

    async loadiFirmDeliveryMethods() {
        try {
            const result = await this.iframeMessagesService.postMessageResp("getiFirmDeliveryMethods", {}, "gotiFirmDeliveryMethods");
            if (result.status === "success") {
                this.iFirmDeliveryMethods = result.deliveryMethods as IiFirmDeliveryMethod[];
                return this.iFirmDeliveryMethods;
            }
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        } catch {
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        }
    }

    async getiFirmDeliveryMethods(): Promise<IiFirmDeliveryMethod[]> {
        if (!this.iFirmDeliveryMethodsLoadPromise) {
            this.iFirmDeliveryMethodsLoadPromise = this.loadiFirmDeliveryMethods();
        }
        return this.iFirmDeliveryMethodsLoadPromise;
    }
}
